import { NEWSLETTER_OPTIONS } from "@components/_profile/Newsletter"
import { Button } from "@components/ui/button"
import { CleanIconButton } from "@components/ui/button/CleanIconButton"
import Captcha from "@components/ui/form/Captcha"
import { Field } from "@components/ui/form/Field"
import IconEyeClosed from "@components/ui/icons/IconEyeClosed"
import IconEyeOpened from "@components/ui/icons/IconEyeOpened"
import { ToolTip } from "@components/ui/tooltip"
import { Heading } from "@components/ui/typograhpy/Heading"
import { Text } from "@components/ui/typograhpy/Text"
import { useFormikContext } from "formik"
import React, { FC, useState } from "react"
import { SignupFormValues } from "./hooks/use-signup-form"

type SignupFormFieldsProps = {
  status: "idle" | "loading"
}

export const SignupFormFields: FC<SignupFormFieldsProps> = ({ status }) => {
  const [showFirstPassword, setShowFirstPassword] = useState(false)
  const [showSecondPassword, setShowSecondPassword] = useState(false)
  const { values } = useFormikContext<SignupFormValues>()

  return (
    <>
      <div className="grid grid-cols-[1fr_1fr] gap-x-4">
        <Field
          autoFocus
          name="firstNameHjJKLS"
          field="input"
          label="First name"
          autoComplete="given-name"
          validation={{
            required: true,
          }}
        />
        <Field
          name="lastNameHjJKLS"
          field="input"
          label="Last name"
          autoComplete="family-name"
          validation={{
            required: true,
          }}
        />
      </div>
      <Field
        name="emailHjJKLS"
        type="email"
        field="input"
        label="Email address"
        autoComplete="email"
        validation={{
          required: true,
          email: true,
        }}
      />
      <Field
        name="password"
        field="input"
        type={showFirstPassword ? "text" : "password"}
        label="Password"
        info="Must have at least 8 characters, 1 uppercase letter, 1 digit."
        validation={{
          required: true,
          password: true,
        }}
        suffix={
          <CleanIconButton
            tabIndex={-1}
            onClick={() => setShowFirstPassword((val) => !val)}
            variant="white-to-white"
            label="Toggle password visibility"
            type="button"
          >
            {showFirstPassword ? <IconEyeOpened /> : <IconEyeClosed />}
          </CleanIconButton>
        }
      />
      <Field
        name="repeatPassword"
        field="input"
        type={showSecondPassword ? "text" : "password"}
        label="Repeat password"
        validation={{
          required: true,
          shouldEqualPassword: values.password,
        }}
        suffix={
          <CleanIconButton
            tabIndex={-1}
            onClick={() => setShowSecondPassword((val) => !val)}
            variant="white-to-white"
            label="Toggle password visibility"
            type="button"
          >
            {showSecondPassword ? <IconEyeOpened /> : <IconEyeClosed />}
          </CleanIconButton>
        }
      />
      <Field
        field="select"
        name="foundViesusThrough"
        label="How did you find Viesus?"
      >
        <option value="" selected disabled>
          How did you find Viesus?
        </option>
        <option value="sales_rep">Sales representative</option>
        <option value="search_engine">Search engine</option>
        <option value="product_hunt">Product Hunt</option>
        <option value="friends_family">Friends/family</option>
        <option value="professional_network">Professional network</option>
        <option value="other">Other</option>
      </Field>
      <Heading variant="h6" as="h6" className="mb-2">
        Newsletter
      </Heading>
      <Text variant="regular" className="mb-4">
        Want to stay updated on all things Viesus Cloud? Sign up for our
        newsletter!
      </Text>
      {NEWSLETTER_OPTIONS.map((option) => (
        <Field
          key={option.preferenceId}
          field="checkbox"
          name={`newsPreference.${option.preferenceId}`}
          label={
            <ToolTip alignOffset={10} trigger={option.label}>
              {option.tooltip}
            </ToolTip>
          }
          id={option.preferenceId}
        />
      ))}
      <Captcha />
      <Button
        variant="primary"
        type="submit"
        as="button"
        width="fill"
        status={status}
      >
        Create account
      </Button>
    </>
  )
}
